import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme } from '@mui/material';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { closePdfModal } from 'store/slices/pdfViewer';

export default function PdfViewerModal() {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { open, pdfUrl, modalTitle } = useSelector((state) => state.pdfModal);

    const handleClose = () => {
        dispatch(closePdfModal());
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = pdfUrl; // Use the URL of the PDF file
        link.download = modalTitle?.split(' ').join('-'); // Use the file name from the URL
        link.click();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="pdf-viewer-dialog-title"
            maxWidth="lg"
            fullWidth
            sx={{
                '& .MuiPaper-root': {
                    width: '80%',
                    maxWidth: 'none'
                }
            }}
        >
            <DialogTitle>{modalTitle}</DialogTitle>
            <DialogContent dividers>
                <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
                    <Viewer fileUrl={pdfUrl} />
                </Worker>
            </DialogContent>
            <DialogActions>
                <Button sx={{ color: theme.palette.error.dark }} autoFocus onClick={handleDownload} color="primary">
                    Download
                </Button>
                <Button sx={{ color: theme.palette.error.dark }} autoFocus onClick={handleClose} color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
